@import 'apps/webcomponents/src/assets/style-helpers.scss';
@import 'apps/webcomponents/src/assets/common.scss';

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

#integration_name {
  width: 240px;
  float: left;
  margin-bottom: 30px;
}

.compact {
  #integration_name {
    margin-bottom: 0;
  }
}

#company_name {
  padding-bottom: 17px;
  font-weight: 570 !important;
}

#confirmed_requirements_button {
  float: right;
  position: absolute;
  right: 40px;
}

#edit-integration {
  padding-bottom: 40px;
}
